import React, { useState, useEffect } from "react";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import { useTranslation } from "react-i18next";
import BookingHistoryCard from "../../../../components/card/bookingHistoryCard";
import {
  getBookingHistoryDetail,
  getBookingDetail,
} from "../../../../redux/booking/BookingSlice";
import { useSelector, useDispatch } from "react-redux";
import { Dropdown, Pagination } from "react-bootstrap";
import BookingDepositCard from "../../../../components/card/bookingDepositCard";
import Sail from "../../../../Asset/image/yacht/Sail.gif";

const BookingHistory = () => {
  const { t } = useTranslation();
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const getToken = useSelector((state) => state.AuthSlice.token);

  // Pagination states
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  // Track which booking card should display the additional box
  const [expandedBooking, setExpandedBooking] = useState(null);

  useEffect(() => {
    Promise.all([
      dispatch(getBookingHistoryDetail({ token: getToken })),
      dispatch(getBookingDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch, getToken]);

  const booking = loading ? null : todos.Booking.BookingHistroy?.results ?? [];

  // Create lookup objects
  const yachtInfoLookup =
    todos.YachtInformationSlice.YachtInformation?.results?.reduce(
      (acc, yacht) => {
        acc[yacht.id_yachtInfo] = yacht.id_marina;
        return acc;
      },
      {}
    ) ?? {};

  const marinaLookup =
    todos.CenterDataSlice.Marina?.results?.reduce((acc, marina) => {
      acc[marina.id_marina] = marina;
      return acc;
    }, {}) ?? {};

  const provinceLookup =
    todos.CenterDataSlice.Province?.results?.reduce((acc, province) => {
      acc[province.ProvinceID] = province;
      return acc;
    }, {}) ?? {};

  const yachtLookup =
    todos.YachtSlice.Yacht?.results?.reduce((acc, yacht) => {
      acc[yacht.id_yacht] = yacht.name_yacht;
      return acc;
    }, {}) ?? {};

  const enhancedBooking = booking
    ?.map((item) => {
      const id_marina = yachtInfoLookup?.[item.id_yachtInfo] ?? null;
      const marinaDetails = id_marina ? marinaLookup?.[id_marina] ?? {} : {};
      const provinceDetails = marinaDetails.id_province
        ? provinceLookup?.[marinaDetails.id_province] ?? {}
        : {};
      const yachtName = yachtLookup?.[item.id_yacht] ?? "";
      const yachtInfo =
        todos.YachtInformationSlice.YachtInformation?.results?.find(
          (yacht) => yacht.id_yachtInfo === item.id_yachtInfo
        );
      const yachtImageUrl = yachtInfo?.logo_yachtInfo_url ?? "";

      return {
        ...item,
        id_marina,
        ...marinaDetails,
        provinceNameEng: provinceDetails?.ProvinceEng ?? "",
        provinceNameThai: provinceDetails?.ProvinceThai ?? "",
        yachtName,
        yachtImageUrl,
      };
    })
    .sort((a, b) => b.id_booking - a.id_booking);

  const uniqueBooking = enhancedBooking?.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.id_booking === item.id_booking)
  );

  // Separate recent booking
  const recentBooking = uniqueBooking?.slice(0, 1);
  const bookingHistory = uniqueBooking?.slice(1);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentBookings = bookingHistory?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handleItemsPerPageChange = (num) => {
    setItemsPerPage(num);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleCloseExpanded = () => {
    setExpandedBooking(null);
  };

  const totalPages = Math.ceil((bookingHistory?.length ?? 0) / itemsPerPage);

  const handleBookNowClick = (idBooking) => {
    setExpandedBooking((prevState) =>
      prevState === idBooking ? null : idBooking
    );
  };

  const [activeStep, setActiveStep] = useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <div>
      <img
        className="BoatHelm-1 mt-5vh"
        draggable={false}
        src={BoatHelm}
        alt="BoatHelm"
      />
      <h3>{t("Booking History")}</h3>
      <div className="text-left">
        <h2>{t("Recent Booking")}</h2>
      </div>
      {recentBooking?.length === 0 ? (
        <p>{t("No Booking History")}</p>
      ) : (
        recentBooking?.map((item, index) => (
          <div className="mb-30" key={index}>
            <BookingHistoryCard
              pending={item.pending}
              yachtName={item.yacht_name}
              date={item.activity_date}
              agent={item.yachtName}
              status={item.status}
              rateType={item.activity_type}
              price={item.sum_all_price}
              marinaNameEn={item.name_marina_en}
              marinaNameTh={item.name_marina_th}
              provinceNameEng={item.provinceNameEng}
              provinceNameThai={item.provinceNameThai}
              yachtImageUrl={item.yachtImageUrl}
              idBooking={item.id_booking}
              bookingNo={item.booking_no}
              payment={item.payment}
              adult={item.adult}
              child={item.child}
              infant={item.infant}
              firstName={item.firstName}
              lastName={item.lastName}
              guest_name={item.guest_name}
              email={item.email}
              mobileNo={item.mobileNo}
              onBookNowClick={handleBookNowClick}
            />
            {expandedBooking === item.id_booking && (
              <div className="mt-5vh">
                <BookingDepositCard
                  initialFormFields={{
                    yachtName: item.yacht_name,
                    contactPerson: item.guest_name,
                    mobileNumber: item.mobileNo,
                    email: item.email,
                    noOfAdults: item.adult,
                    noOfChildren: item.child,
                    noOfInfants: item.infant,
                    depositAmount: item.sum_all_price,
                    typeActivity: item.activity_type,
                    yachtInfo: item.id_yachtInfo,
                    yachtId: item.id_yacht,
                    IdBooking: item.id_booking,
                  }}
                  activeStep={activeStep}
                  handleStepChange={handleStepChange}
                  onClose={handleCloseExpanded}
                />
              </div>
            )}
          </div>
        ))
      )}
      <div
        className="flex-between-center"
      >
        <h2>{t("Booking History")}</h2>
        <div>
          <span>{t("show bookings")} </span>
          <Dropdown
            onSelect={(e) => handleItemsPerPageChange(Number(e))}
            className="d-inline-block"
          >
            <Dropdown.Toggle
              variant="secondary"
              id="dropdown-basic"
              className="dropdown-items"
            >
              {itemsPerPage}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="5">5</Dropdown.Item>
              <Dropdown.Item eventKey="10">10</Dropdown.Item>
              <Dropdown.Item eventKey="15">15</Dropdown.Item>
              <Dropdown.Item eventKey="20">20</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <hr className="border-top-full" />
      {bookingHistory?.length === 0 ? (
        <p>{t("No Booking History")}</p>
      ) : (
        currentBookings?.map((item, index) => (
          <div className="mb-30" key={index}>
            <BookingHistoryCard
              pending={item.pending}
              yachtName={item.yacht_name}
              date={item.activity_date}
              agent={item.yachtName}
              status={item.status}
              rateType={item.activity_type}
              price={item.sum_all_price}
              marinaNameEn={item.name_marina_en}
              marinaNameTh={item.name_marina_th}
              provinceNameEng={item.provinceNameEng}
              provinceNameThai={item.provinceNameThai}
              yachtImageUrl={item.yachtImageUrl}
              payment={item.payment}
              idBooking={item.id_booking}
              bookingNo={item.booking_no}
              adult={item.adult}
              child={item.child}
              infant={item.infant}
              firstName={item.firstName}
              lastName={item.lastName}
              guest_name={item.guest_name}
              email={item.email}
              mobileNo={item.mobileNo}
              onBookNowClick={handleBookNowClick}
            />
            {expandedBooking === item.id_booking && (
              <div className="mt-5vh">
                <BookingDepositCard
                  initialFormFields={{
                    yachtName: item.yacht_name,
                    contactPerson: item.guest_name,
                    mobileNumber: item.mobileNo,
                    email: item.email,
                    noOfAdults: item.adult,
                    noOfChildren: item.child,
                    noOfInfants: item.infant,
                    depositAmount: item.sum_all_price,
                    typeActivity: item.activity_type,
                    yachtInfo: item.id_yachtInfo,
                    yachtId: item.id_yacht,
                    IdBooking: item.id_booking,
                  }}
                  activeStep={activeStep}
                  handleStepChange={handleStepChange}
                  onClose={handleCloseExpanded}
                />
              </div>
            )}
          </div>
        ))
      )}
      <Pagination className="d-flex justify-content-center circular-pagination">
        <Pagination.Item
          className="prev"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          &lt;
        </Pagination.Item>
        {Array.from({ length: totalPages }, (_, index) => index + 1)
          .filter((number) => {
            return (
              number === 1 ||
              number === totalPages ||
              (number >= currentPage - 1 && number <= currentPage + 1)
            );
          })
          .reduce((acc, number, idx, arr) => {
            if (idx > 0 && number - arr[idx - 1] > 1) {
              acc.push("ellipsis");
            }
            acc.push(number);
            return acc;
          }, [])
          .map((item, idx) =>
            item === "ellipsis" ? (
              <Pagination.Ellipsis key={`ellipsis-${idx}`} disabled />
            ) : (
              <Pagination.Item
                key={item}
                active={item === currentPage}
                onClick={() => handlePageChange(item)}
              >
                {item}
              </Pagination.Item>
            )
          )}
        <Pagination.Item
          className="next"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          &gt;
        </Pagination.Item>
      </Pagination>

      {loading && (
        <div
          className="fullscreen-overlay"
          aria-label="Loading"
          role="status"
        >
          <img
            src={Sail} // ถ้าใช้ไฟล์ใน public ให้เปลี่ยนเป็น "/Sail.gif"
            alt="Loading..."
            className="image-modal"
            draggable={false}
          />
        </div>
      )}
    </div>
  );
};

export default BookingHistory;
